var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useCallback } from 'react';
import { useCallbackDebouncedPromisified, useUpdate, useUpdatedRef, } from '../../../custom-hooks';
const DEFAULT_ERRORS = [];
const VALIDATING_ERRORS = [
    { code: 'errorValidating', message: 'Error validating', path: [] },
];
export const useFieldValidate = ({ isValidating, setValidity, updatedDependency, validationDebounceTime, validator, value, }) => {
    _react_refresh_temp_1();
    const validatorRef = useUpdatedRef(validator);
    const validateField = useCallback(async (valueToValidate, dependencyValue) => {
        let validityCheck;
        if (validatorRef.current) {
            try {
                validityCheck = await validatorRef.current(valueToValidate, dependencyValue);
            }
            catch (error) {
                validityCheck = {
                    errors: VALIDATING_ERRORS,
                    isValid: false,
                };
            }
        }
        else {
            validityCheck = {
                errors: DEFAULT_ERRORS,
                isValid: true,
            };
        }
        setValidity(validityCheck, {
            dependencyValue,
            value: valueToValidate,
        });
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps -- WIP
    []);
    const validateFieldDebounced = useCallbackDebouncedPromisified({
        fn: validateField,
        fnDeps: [validateField],
        timeout: validationDebounceTime || 0,
    });
    useUpdate(async () => {
        if (isValidating) {
            if (validationDebounceTime !== undefined) {
                await validateFieldDebounced(value, updatedDependency);
            }
            else {
                await validateField(value, updatedDependency);
            }
        }
    }, [isValidating, updatedDependency, value]);
};
_react_refresh_temp_1(useFieldValidate, "Chvv9BEXaw925QLL9I409L/gibs=", false, () => [useUpdatedRef, useCallbackDebouncedPromisified, useUpdate]);
